import React from 'react';
import './Modal.css';
import plannerIcon from "../../assets/images/Icon=planner.svg";
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import { t } from '../../locales/translate';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";

const SubmitPlanModal = ({ isVisible, onClose, onSubmitClick, isLoading }) => {
    const [loading, setLoading] = React.useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await onSubmitClick();
        } catch (error) {
            console.error("Error submitting:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        isVisible && (
            <div className="modal-backdrop">
                <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                    <LoadingOverlay isVisible={loading} />
                    <div className={loading ? 'blur' : ''}>
                        <div className='content-container'>
                            <div className='icon-container'>
                                <img src={plannerIcon} />
                            </div>
                            <div className='text-container'>
                                <Heading6Semibold color='#1E293B' text={t("submitPlan")} />
                                <BodyMediumRegular
                                    color='#384153'
                                    text={t("submitPlanTip")}
                                    textAlign='center'
                                />
                            </div>
                        </div>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '8px', 
                            padding: '12px 20px',
                            backgroundColor: '#E1E8FF',
                            borderRadius: '12px',
                            marginBottom: '16px'
                        }}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="9" fill="#3B82F6" stroke="#3B82F6" strokeWidth="2"/>
                                <text x="10" y="14" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">i</text>
                            </svg>
                            <BodyExtraSmallMedium 
                                color='#1E40AF' 
                                text="Once approved, all tasks for this plan will be created."
                            />
                        </div>
                        <div className='button-contiainer'>
                            <button className='cancel-button'
                                onClick={onClose}
                            >
                                {t("cancel")}
                            </button>
                            <button className='primary-button' onClick={handleSubmit} disabled={loading}>
                                {t("submit")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

export default SubmitPlanModal;